<template>
  <div class="horizontal-value-bar__wrapper" v-if="available" :class="small ? 'small': ''">
    <v-tooltip left open-delay="200">
      <template v-slot:activator="{ on, attrs }">
        <div class="horizontal-value-bar__details" v-bind="attrs" v-on="on" >
          <v-icon class="mr-2" v-if="!small">{{icon}}</v-icon>
          <label class="mr-2">{{valuePercentage}}%</label>
          <p class="mb-0"><strong>{{value}} {{details.unit}}</strong> / {{total}} {{details.unit}}</p>
        </div>
        <div class="horizontal-value-bar" :class="type">
          <span v-if="value" :style="{width:valueCalculated+'%'}"></span>
          <span v-if="valueOver" :style="{width:valueOver+'%'}"></span>
        </div>
      </template>
      {{details.tooltip}}
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: 'HorizontalValueBar',
  props: {
    value: {
      type: Number,
      default: 0
    },
    total: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: 'time'
    },
    small: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      displayNumber:0,
      interval:false
    }
  },
  computed: {
    available() {
      return !!(this.value >= 0 && this.total)
    },
    valuePercentage() {
      if (this.total) return Math.round(this.value/this.total*100)
      else return 0
    },
    valueCalculated() {
      return this.total > 0 ? (this.value < this.total ? this.value/this.total*100 : 100) : 0 // no dividing by 0 and max value 100
    },
    valueOver() {
      if (this.value > this.total) {
        let val = (this.value - Math.floor(this.value/this.total)*this.total)/this.total * 100
        if (val == 0) val = 100
        return val
      } 
      else return 0
    },
    icon() {
      let icon = ''
      switch (this.type) {
        case 'time':
        icon = 'bhi-clock2'
        break
        case 'weight':
        icon = 'bhi-exercise'
        break
        case 'distance':
        icon = 'bhi-activity'
        break
        case 'steps':
        icon = 'bhi-walk'
        break
        case 'score':
        icon = ''
        break
      }
      return icon
    },
    details() {
      let unit = ''
      let tooltip = ''
      switch (this.type) {
        case 'time':
        unit = 'min'
        tooltip = 'Time spent'
        break
        case 'weight':
        unit = 'lbs'
        tooltip = 'Pounds lifted'
        break
        case 'distance':
        unit = 'm'
        tooltip = 'Distance moved'
        break
        case 'steps':
        unit = 'steps'
        tooltip = 'Steps'
        break
        case 'repetitions':
        unit = 'reps'
        tooltip = 'Repetitions'
        break
        case 'restTimeBetweenSeries':
        unit = 'secs'
        tooltip = 'Rest time between sets'
        break
        case 'score':
        unit = ''
        tooltip = ''
        break
      }
      return {unit: unit, tooltip: tooltip}
    }
  }
}
</script>
<style lang="scss" scoped>
.horizontal-value-bar {
  display: flex;
  overflow: hidden;
  border-radius: 2px;
  position: relative;
  height: 4px;
  width: 100%;
  &__wrapper {
    margin-bottom: 16px;
    label {
      width: 40px;
      flex-shrink: 0;
    }
    &.small {
      margin-bottom: 8px;
      font-size: 10px;
      label {
        width: 30px;
      }
      label, p {
        font-size: 10px;
      }
    }
  }
  &__details {
    color:$bh-gray;
    margin-bottom: 2px;
    display: flex;
    align-items: center;
  }
  &.time {
    span:nth-child(1) {
      background: rgba(0, 160, 224, 0.6);
    }
    span:nth-child(2) {
      background: rgba(0, 160, 224, 1);
    }
  }
  &.weight {
    span:nth-child(1) {
      background: rgba(231, 138, 61, 0.6);
    }
    span:nth-child(2) {
      background: rgba(231, 138, 61, 1);
    }

  }
  &.distance {
    span:nth-child(1) {
      background: rgba(85, 203, 35, 0.6);
    }
    span:nth-child(2) {
      background: rgba(85, 203, 35, 1);
    }

  }
  &.steps {
    span:nth-child(1) {
      background: rgba(148, 94, 255, 0.6);
    }
    span:nth-child(2) {
      background: rgba(148, 94, 255, 1);
    }

  }
  span {
    display: block;
    height: 4px;
    position: relative;
    transition-duration: 600ms;
    border-radius: 2px;
    position: absolute;
    left: 0;
    top: 0;
    &:nth-child(1) {
      background: rgba(0, 160, 224, 0.6);
      z-index: 1;
    }
    &:nth-child(2) {
      background: rgba(0, 160, 224, 1);
      z-index: 2;
    }
  }
}
</style>